import { EReminderTargetEntity } from "../enums/reminders.enums";
import { Reminder } from "../interfaces/IRemiders";

export const filterRemindersByTarget = (reminders: Reminder[]) => {
    return {
        admins: reminders?.filter(
            (reminder) => reminder.targetEntity === EReminderTargetEntity.COMPANY
        ),
        clients: reminders?.filter(
            (reminder) => reminder.targetEntity === EReminderTargetEntity.CLIENT
        ),
        workforce: reminders?.filter(
            (reminder) => reminder.targetEntity === EReminderTargetEntity.WORKFORCE
        ),
    };
};